import { useParams, useSearchParams } from 'react-router-dom';
import AddCampaignContainer from 'modules/campaigns/containers/AddCampaignContainer';
import NotFoundContainer from 'modules/general/containers/NotFoundContainer';

const AddAdvertiserView = () => {
  const [searchParams] = useSearchParams();

  const { id: campaignKey } = useParams();
  const advertiserKey = searchParams.get('advertiserKey');

  if (campaignKey || advertiserKey) return <AddCampaignContainer />;
  return <NotFoundContainer />;
};

export default AddAdvertiserView;
